import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';
import { AirportComponent } from '../airport/airport.component';

@Component({
  selector: 'app-airport-list',
  templateUrl: './airport-list.component.html',
  styleUrls: ['./airport-list.component.css']
})
export class AirportListComponent implements OnInit {

  public menu_item_id = '86';
  public add_auth;
  public edit_auth;
  public del_auth;
  
  private dp = [];
  displayedColumns = ['airport_name', 'airport_name_en', 'airport_code', 'country_name', 'city_name', 'edit', 'del'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<AirportComponent>;
  @ViewChild(MatSort) sort: MatSort;

  model = { 'table_name': 'airport', 'airport_name': '', 'airport_code': '' };

  Success_Msg; Error_Msg; Del_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);
  }

  search() {

    let condition = "";

    if (this.model['airport_name'] != '')
      condition += " (`airport_name` LIKE '%" + this.model['airport_name'] +
        "%' OR `airport_name_en` LIKE '%" + this.model['airport_name'] + "%') AND ";

    if (this.model['airport_code'] != '')
      condition += " `airport_code` LIKE '%" + this.model['airport_code'] + "%' AND ";

    let query = "SELECT `airport`.*, `city`.`city_name`, `country`.`country_name`,"
      + "`country`.`country_id` FROM `airport`, `city`,`country` WHERE" + condition
      + " `airport`.`status` = '1' AND `airport`.`city_id` = `city`.`city_id` AND"
      + " `country`.`country_id` = `city`.`country_id`";
      
    let obj = { cmd: 'getList', query: query };
    console.log(query);
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  newAirport() {
    this.addDialogRef = this.dialog.open(AirportComponent, {
      hasBackdrop: false,
      //data: this.dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['status'] == 'success')
          this.search();
      });
  }

  editAirport(row) {
    let dialog_data = [{
      'table_name': 'airport', 'airport_id': row.airport_id,
      'airport_name': row.airport_name,
      'airport_name_en': row.airport_name_en,
      'city_id': row.city_id,
      'airport_code': row.airport_code,
      'comment': row.comment
    },
    { 'country_id': row.country_id }];

    this.addDialogRef = this.dialog.open(AirportComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        this.search();
      });
  }

  delAirport(row) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'airport_id': row.airport_id }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          //console.log(data);
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }


}
